import { PriceModel } from './price.model';

export class PriceInfoModel {

  monthlyRecurringFee: PriceModel;
  oneTimeFee: PriceModel;
  totalPrice: PriceModel;
  id: string;

  constructor() {
    this.monthlyRecurringFee = undefined;
    this.oneTimeFee = undefined;
    this.totalPrice = undefined;
    this.id = undefined;
  }
}
